import { useLayoutEffect, useRef } from "react";
import { useBeforeUnmount } from "web_myplann/Shared/Hooks/useBeforeUnmount";
import { useHistoryEntryState } from "web_myplann/Shared/Hooks/useHistoryEntryState";

export const useHistoryEntryScroll = (key: string, isReady = true) => {
	const { saved, save } = useHistoryEntryState<number>(key);
	const scrollRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (isReady && saved) scrollRef.current?.scrollTo({ top: saved });
	}, [saved, isReady]);

	useBeforeUnmount(() => save(scrollRef.current?.scrollTop ?? 0));

	return scrollRef;
};
